
import api from '@/api/connect';
import { IUser } from '@/types/models';
import utils from '@/utils';
import { defineComponent } from 'vue';
import { PAGE_TYPE_AUTH, PAGE_TYPE_LOGIN } from '../pageType';

interface IState {
  user: IUser;
  token: string;
}

export default defineComponent({
  data() {
    return {
      user: {} as IUser,
      token: '',
    } as IState;
  },
  methods: {
    getAvatarUrl() {
      return utils.getAvatarUrl(this.user);
    },

    btnApproveClick() {
      window.parent.postMessage({
        userName: this.user.userName,
        token: this.token,
      }, '*');
    },

    btnSwitchClick() {
      this.$emit('redirect', PAGE_TYPE_LOGIN);
    },
  },
  mounted() {
    api.get((res) => {
      if (res.isAuthenticated && res.user && res.token) {
        this.user = res.user;
        this.token = res.token;
      } else {
        this.$emit('redirect', PAGE_TYPE_AUTH);
      }
    });
  },
});
